export const isWrongNetwork = (network) => (network === 1 && window.__APP_CONFIG.envName !== "mainnet") ||
    (network === 0 && window.__APP_CONFIG.envName === "mainnet");
//# sourceMappingURL=network.utils.js.map